<template>
  <RemotePaginatedList :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       v-model="selectedItemIds"
                       data-url="admin/whitelist/"
                       data-key="whitelist"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs"
                       class="admin-list">
    <template v-slot:item.actions="{item}">
      <v-menu offset-y
              rounded
              left>
        <template v-slot:activator="{on}">
          <v-btn icon
                 v-on="on">
            <v-icon>fas fa-cog</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="deleteItem(item)">
            <v-icon>mdi-delete-outline</v-icon>
            <label class="ml-3 font-weight-medium">{{ $t('whitelist.delete') }}</label>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </RemotePaginatedList>
</template>

<script>
import {onMounted, ref, watch} from '@vue/composition-api'
import AdvancedSearchInput from "../AdvancedSearchInput";
import RemotePaginatedList from "../RemotePaginatedList";
import {USER_TYPE} from "@/constants";
import {ACTION_TYPES} from "@/store/types";

export default {
  name: 'AdfsWhiteListList',
  components: {RemotePaginatedList, AdvancedSearchInput},
  props: {
    value: Array,
    refreshTrigger: Boolean,
  },
  setup(props, {root, emit}) {
    const refresh = function (forceReload) {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh(false);
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh(true);
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = ref([
      {text: root.$t('whitelist.username'), value: 'username', contains: true},
    ])

    // Data Table
    const headers = ref([
      {text: root.$t('whitelist.username'), value: 'username'},
      {text: '', value: 'actions', sortable: false, width: 50},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });
    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    const deleteItem = async function (item) {
      if (await root.$dialog.confirm({text: root.$t('whitelist.delete_confirm_msg')})) {
        await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: 'admin/whitelist/delete/',
          params: {
            whitelist_id: item.id,
          }
        });

        refresh();
      }
    }

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      deleteItem,

      USER_TYPE,
    }
  }
}
</script>

<style lang="less">
.admin-list {
  .disabled {
    text-decoration: line-through;
  }
}
</style>
